import React, { useEffect, useRef } from "react";
import "../assets/styles/About.css";
import AboutImg from "../assets/sunleaf-villa.png"; // ← update path if needed

/* ── Scroll reveal hook ── */
function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return ref;
}

// const STATS = [
//   { num: "12+", label: "Luxury Rooms" },
//   { num: "8yr", label: "Of Excellence" },
//   { num: "4.9", label: "Guest Rating" },
//   { num: "98%", label: "Happy Guests" },
// ];

const FEATURES = [
  "Luxury suites and premium rooms",
  "Rooftop swimming pool with city views",
  "Private party hall for celebrations",
  "Spacious meeting & event spaces",
];

function About() {
  const eyebrowRef = useReveal();
  const titleRef = useReveal();
  const body1Ref = useReveal();
  const body2Ref = useReveal();
  const featuresRef = useReveal();
  const ctaRef = useReveal();
  const imageRef = useReveal();
  // const statsRef = useReveal();

  return (
    <section id="about" className="about-section">
      <div className="container-fluid px-4 px-lg-5">
        <div className="row align-items-center g-5">
          {/* ── LEFT — Text ── */}
          <div className="col-12 col-lg-6 order-2 order-lg-1">
            <div
              ref={eyebrowRef}
              className="about-eyebrow reveal reveal-delay-1"
            >
              Our Story
            </div>

            <h2 ref={titleRef} className="about-title reveal reveal-delay-2">
              A Sanctuary Built
              <br />
              for <em>Timeless</em> Living
            </h2>

            <p ref={body1Ref} className="about-body reveal reveal-delay-3">
              Nestled among sun-drenched terraces and whispering palms, Sunleaf
              Villa was founded with a single belief — that true luxury is found
              in stillness, warmth, and the beauty of the natural world.
            </p>

            <p ref={body2Ref} className="about-body reveal reveal-delay-3">
              Every corner of our villa has been thoughtfully crafted to offer
              an escape from the ordinary. From hand-selected furnishings to
              garden-fresh cuisine, each detail reflects our commitment to
              refined, effortless hospitality.
            </p>

            <div className="about-divider" />

            <ul
              ref={featuresRef}
              className="about-features reveal reveal-delay-3"
            >
              {FEATURES.map((f) => (
                <li key={f}>
                  <span className="feature-dot" />
                  {f}
                </li>
              ))}
            </ul>

            <a
              ref={ctaRef}
              href="#rooms"
              className="about-cta reveal reveal-delay-4"
            >
              Discover Our Rooms
              <span className="cta-arrow">→</span>
            </a>
          </div>

          {/* ── RIGHT — Single image ── */}
          <div className="col-12 col-lg-6 order-1 order-lg-2 about-image-col">
            <div ref={imageRef} className="about-image-wrap reveal-right">
              {/* Single clean image */}
              <div className="about-image-frame">
                <img src={AboutImg} alt="Sunleaf Villa" />
              </div>
            </div>
          </div>
        </div>

        {/* ── Stats row ── */}
        {/* <div ref={statsRef} className="about-stats reveal reveal-delay-2">
          {STATS.map(({ num, label }) => (
            <div className="about-stat" key={label}>
              <span className="stat-num">{num}</span>
              <span className="stat-label">{label}</span>
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
}

export default About;
